import React from 'react';
import {Routes, Route} from 'react-router';

import {Confirmation} from './Confirmation';
import {SignupForm} from './Form';
import {SignupSuccess} from './Success';

const Signup = () => (
  <>
    <Routes>
      <Route path="confirmation/:token" element={<Confirmation />} />
      <Route path="success" element={<SignupSuccess />} />
      <Route index element={<SignupForm />} />
    </Routes>
  </>
);

export {Signup};
